export const SendMessageRoutes = [
  {
    path: "/Admin/SendMessage/SendByPerson",
    name: "定向消息推送",
    component: () => import("./SendByPerson/index.vue"),
    meta: {
      title: "定向消息推送"
    }
  },
  {
    path: "/Admin/SendMessage/SendSiteWide",
    name: "公告消息推送",
    component: () => import("./SendSiteWide/index.vue"),
    meta: {
      title: "公告消息推送"
    }
  }
];



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/SendMessage/routes.js